<template>
	<div class="home-container"  v-loading="loading">
		<div class="box1">
			<div class="cont mainCont">
				<div class="b_left">
					<div class="item" v-for="(item,index) in sortArr" :key="index">
						<div class="i_tit" @click="goServer(item.id)">
							<h4>{{item.typeName}}</h4>
							<i class="iconfont icon-right"></i>
						</div>
						<div class="tip" v-if="item.children&&item.children.length">
							<span v-for="(itemIn,i) in item.children" :key="i" @click="goServer(item.id,itemIn.id)">{{itemIn.typeName}}</span>
						</div>
					</div>
				</div>
				<!-- 轮播图 -->
				<div class="b_min">
					<!-- 轮播图 -->
					<div class="bnner">
						<el-carousel height="344px">
							<el-carousel-item v-for="(item,i) in banner" :key="i">
							  <img :src="item.img" alt="1" class="img">
							</el-carousel-item>
						</el-carousel>
					</div>
					<!-- 师傅-->
					<div class="b_master">
						<template v-for="(item,i) in sfList">
							<div class="item"  v-if="i<2" :key="i" @click="goMaster(item)">
								<div class="img"><img :src="item.headImg||'../../../static/master.png'" alt="1"></div>
								<div class="txt">
									<div class="name">
										<h5>{{item.name||'--'}}</h5>
                                     <p class="type" v-if="item.sfrzStatus==='1'">已实名</p>

									 <!-- 奖牌图标 -->
                                    <img  src="../../../static/jz2.png" alt="奖牌" class="medal-icon">
										<div class="xing"><i class="iconfont icon-lujing"></i><span></span>{{item.sfscore || '--'}}</div>
									</div>
									<div class="tips" v-if="item.sclyArr">
										<span class="s_tip" v-for="(itemIn,x) in item.sclyArr" v-if="x<2"  :key="x">{{itemIn}}</span>
									</div>
									     <!-- tips 为空时，给它加一个最小高度 -->
                                      <div class="tips" v-else></div>
									<div class="t_foot">
										<span>已服务{{item.sffwnum||0}}人</span>
										<button class="btn">立即报修</button>
									</div>
								</div>
							</div>
						</template>
					</div>
				</div>
				<!-- 一键报修 -->
				<div class="b_right">
					<h3>一键报修</h3>
					<p>填写信息发布报修</p>
					<div class="item">
						<el-cascader 
						v-model="serverVal" 
						:options="serverList" :props="{value:'id',label:'typeName'}"
						@change="handleChangeServer"
						  placeholder="请选择服务器">
						></el-cascader>
					</div>
					<div class="item">
						<el-select no-data-text="请先选择服务分类" v-model="form.productId" placeholder="请选择服务分类" :popper-append-to-body="false">
							<el-option
							  v-for="item in list"
							  :key="item.id"
							  :label="item.productName"
							  :value="item.id">
							</el-option>
						</el-select>
					</div>
					<div class="item">
						<el-cascader
						v-model="selectedThree"
						:options="options"
						:props="Props" 
						:key="cascaderKey"
						placeholder="请选择省市区" 
						@change="handleChange"
						ref="three"
						></el-cascader>
					</div>
					<div class="item h_auto" style="background: transparent;">
						<el-date-picker @change="changeDate" style="width: 60%;margin-right: 2px;" value-format="yyyy-MM-dd"  format="yyyy-MM-dd" v-model="form.memberYysj" type="datetime" placeholder="请选择时间">
						</el-date-picker>
						<el-select no-data-text="请先选择预约时间" v-model="form.time" placeholder="请选择时间段" :popper-append-to-body="false" style="width: 40%;">
							<el-option
							v-for="item in arrayTime"
							:key="item.h"
							:label="item.val"
							:value="item.val">
							</el-option>
						</el-select>
					</div>
					<div class="item h_auto">
						<el-input type="textarea" v-model="form.content" resize="none" :rows="4" placeholder="请输入维修内容"></el-input>
					</div>
					<div class="item">
						<el-input type="number" v-model="form.mobile" maxlength="11" placeholder="请输入手机号"></el-input>
					</div>
					<div class="item">
						<el-input type="text"  v-model="form.msgCode" placeholder="请输入验证码"></el-input>
						<span class="yan" @click="getVCode()">{{vcodeBtnName}}</span>
					</div>
					<button class="form_btn" @click="submitForm()">提交</button>
				</div>
			</div>
		</div>
		<!-- 产品 -->
		<div class="box2">
			<div class="cont mainCont">
				<div class="item" v-for="(item,index) in productList" :key="index" @click="goDetail(item)">
					<div class="img"><img :src="item.productImg" alt=""></div>
					<div class="txt">
						<h3>{{item.productName}}</h3>
						<p class="text-ellipsis">{{item.misoshu}}</p>
					</div>
				</div>
			</div>
		</div>
		<div class="box3 mainCont">
			<div class="item">
				<img src="../../../static/index/item1.png" alt="1" class="img">
				<div class="txt">
					<h3>迅速下单</h3>
					<p>紧急报修，快速上门</p>
				</div>
			</div>
			<div class="item">
				<img src="../../../static/index/item2.png" alt="1" class="img">
				<div class="txt">
					<h3>确认上门</h3>
					<p>确认上门时间</p>
				</div>
			</div>
			<div class="item">
				<img src="../../../static/index/item3.png" alt="1" class="img">
				<div class="txt">
					<h3>透明施工</h3>
					<p>维修过程监管</p>
				</div>
			</div>
			<div class="item">
				<img src="../../../static/index/item4.png" alt="1" class="img">
				<div class="txt">
					<h3>验收付款</h3>
					<p>现场验收付款</p>
				</div>
			</div>
			<div class="item">
				<img src="../../../static/index/item5.png" alt="1" class="img">
				<div class="txt">
					<h3>评星</h3>
					<p>为师傅服务打分</p>
				</div>
			</div>
		</div>
		<!-- 平台师傅 -->
		<div class="box4 mainCont" v-if="sfList.length">
			<div class="big_title">
				<h2>平台师傅</h2>
				<router-link class="more" to="/master"><span>更多</span><i class="iconfont icon-right"></i></router-link>
				<!-- <div class="more"><span>更多</span><i class="iconfont icon-right"></i></div> -->
			</div>

			<div class="scroll-container">
				
			<div class="b_list">
				<template v-for="(item,index) in sfList2"  >

				 <!-- <div class="scroll-container">
    <div class="scroll-list" :style="{ transform: `translateX(-${scrollPosition}px)` }">	 -->
				<div class="item" :key="index"  @click="goMaster(item)">
					<div class="img"><img :src="item.headImg||'../../../static/master.png'" alt=""></div>
					<div class="txt">
						<h4>{{item.name||'--'}}</h4>
						  <p class="type88" >已实名</p>
						<div class="tips" v-if="item.sclyArr">
							<span class="s_tip" v-for="(itemIn,x) in item.sclyArr" v-if="x<2" :key="x">{{itemIn}}</span>
						</div>
						<div class="i_foot">
							<div class="xing"><i class="iconfont icon-lujing"></i><span></span>{{item.sfscore || '--'}}</div>
							<span>已服务{{item.sffwnum||0}}人</span>
						</div>
					</div>
				</div>
				</template>	


				       <!-- 克隆一份数据，便于无缝滚动 -->
            <template v-for="(item, index) in sfList">
                <div class="item" :key="'clone-' + index" @click="goMaster(item)">
                    <div class="img"><img :src="item.headImg || '../../../static/master.png'" alt=""></div>
                    <div class="txt">
                        <h4>{{item.name || '--'}}</h4>
							  <p class="type88" v-if="item.sfrzStatus==='1'">已实名</p>
                        <div class="tips" v-if="item.sclyArr">
                            <span class="s_tip" v-for="(itemIn, x) in item.sclyArr" v-if="x < 2" :key="x">{{itemIn}}</span>
                        </div>
	                   <!-- tips 为空时，给它加一个最小高度 -->
                       <div class="tips" v-else></div>

                        <div class="i_foot">
                            <div class="xing"><i class="iconfont icon-lujing"></i><span></span>{{item.sfscore || '--'}}</div>
                            <span>已服务{{item.sffwnum || 0}}人</span>
                        </div>
                    </div>
                </div>
            </template>


						       <!-- 克隆一份数据，便于无缝滚动 -->
            <template v-for="(item, index) in sfList">
                <div class="item" :key="'clone-' + index" @click="goMaster(item)">
                    <div class="img"><img :src="item.headImg || '../../../static/master.png'" alt=""></div>
                    <div class="txt">
                        <h4>{{item.name || '--'}}</h4>
						  <p class="type88" v-if="item.sfrzStatus==='1'">已实名</p>
                        <div class="tips" v-if="item.sclyArr">
                            <span class="s_tip" v-for="(itemIn, x) in item.sclyArr" v-if="x < 2" :key="x">{{itemIn}}</span>
                        </div>
						  <!-- tips 为空时，给它加一个最小高度 -->
                       <div class="tips" v-else></div>
                        <div class="i_foot">
                            <div class="xing"><i class="iconfont icon-lujing"></i><span></span>{{item.sfscore || '--'}}</div>
                            <span>已服务{{item.sffwnum || 0}}人</span>
                        </div>
                    </div>
                </div>
            </template>

			</div>


			 <!-- 第二个列表，显示克隆的数据，最初应该是隐藏的 -->
    <!-- <div class="b_list clone">
      <template v-for="(item, index) in sfList2" >
        <div class="item"  :key="index" @click="goMaster(item)">
          <div class="img">
            <img :src="item.headImg || '../../../static/master.png'" alt="">
          </div>
          <div class="txt">
            <h4>{{item.name || '--'}}</h4>
            <div class="tips" v-if="item.sclyArr">
              <span class="s_tip" v-for="(itemIn, x) in item.sclyArr" v-if="x < 2" :key="x">{{itemIn}}</span>
            </div>
            <div class="i_foot">
              <div class="xing">
                <i class="iconfont icon-lujing"></i><span></span>{{item.sfscore || '--'}}
              </div>
              <span>已服务{{item.fwNum || 0}}人</span>
            </div>
          </div>
        </div>
      </template>
    </div> -->





 </div>
  

		</div>
		<!-- 企业资质 -->
		<div class="box5">
			<div class="cont mainCont">
				<h3>企业资质</h3>
				<p>Enterprise Qualification</p>
				<el-carousel height="520px">
					<el-carousel-item v-for="(item,inex) in zzList" :key="inex">
						<div class="mySwiper">
							<div class="swiper-slide" v-for="(itemIn,indexIn) in item" :key="indexIn">
								<img :src="itemIn.img" class="img" alt="">
								<div class="btn">{{itemIn.name}}</div>
						  </div>
						</div>
					</el-carousel-item>
				</el-carousel>
				
			</div>
		</div>
		<!-- 新闻资讯 -->
		<div class="box6 mainCont">
			<div class="big_title">
				<h2>新闻资讯</h2>
				<div class="more" @click="goUrl('/news')"><span>更多</span><i class="iconfont icon-right"></i></div>
			</div>
			<div class="b_listt">
				<div class="l_left" v-for="(item,index) in zxList" :key="index" v-if="index==0" @click="goNews(item)">
					<img :src="item.img" alt="1" class="img">
					<div class="in_title"><h4>{{item.name}}</h4></div>
				</div>
				<div class="l_right">
					<div class="item" v-for="(item,index) in zxList" :key="index" v-if="index>0" @click="goNews(item)">
						<img :src="item.img" alt="1" class="img">
						<div class="txt">
							<h4 class="text-ellipsis">{{item.name}}</h4>
							<p class="text-ellipsisc2">{{item.remark}}</p>
							<span>2024.4.10</span>
						</div>
					</div>
				</div>
			</div>
		</div>
		<!-- 平台案例 -->
		<div class="box7 mainCont">
			<div class="big_title">
				<h2>平台案例</h2>
				<div class="more" @click="goUrl('/case')"><span>更多</span><i class="iconfont icon-right"></i></div>
			</div>
			<div class="list">
				<div class="item" v-for="(item,index) in ptList" :key="index" @click="goCase(item)">
					<img class="img" :src="item.img" alt="1">
					<h4>{{item.title}}</h4>
				</div>
			</div>
		</div>
		<!-- 信息 -->
		<!-- <div class="box8 mainCont">
			<img src="../../../static/index/img.png" alt="1" class="img">
			<div class="r_world">
				<div class="txt">
					<h4>鲸蜗家庭报修</h4>
					<div class="dec" v-html="articeObj.content">
						
					</div>
				</div>
			</div>
		</div> -->
	</div>
</template>
<script>
import {getBannerList,getProvicneCityArea,getShifuMemberList,getProductList,getPtzzList,getArtice,getFwalList,getProductTypeList,getProductTypeAllList,getXwzxList,orderCreate,sendMsgCode} from '@/api/api'
// import {get,post} from '@/utils/request'
import { EventBus } from '@/utils/event-bus.js';
import { provinceAndCityData, regionData} from "element-china-area-data";
export default {
	name: 'home',
	data() {
		return {

			 scrollPosition: 0, // 初始滚动位置
      scrollSpeed: 1, // 滚动速度
      isScrolling: false, // 用于判断是否正在滚动

		//	scrollPosition: 0, // 当前滚动的位置
          itemWidth: 20, // 每个 item 的宽度，您需要根据实际情况调整
         scrollInterval: null, // 存储定时器
			city:'',
			sortArr:[],//服务分类
			serverVal: [],
			isResouceShow:0,
			dec:'',
			loading:true,
			banner:[],//轮播图
			sfList:[],//师傅列表
			sfList2:[],//师傅列表
			productList:[],//产品列表
			zzList:[],//平台资质
			zxList:[],//新闻咨询
			ptList:[],//平台案例
			articeObj:{},//企业简介

			serverList: [],//服务分类
			serverVal: [],
			list:[],//服务产品
			// 省市区级联
			optionsThree: regionData,
			optionsTwo: provinceAndCityData,
			selectedThree: [],
			cascaderKey:1,
			options:[],
			Props: {
				lazy: true,
				// checkStrictly: true,
				lazyLoad: (node, resolve) => {
					console.log(node, 'node');
					let { value = 0 } = node;
					const nodes = [];
					getProvicneCityArea({parentId:value}).then(res => {
						console.log(res)
						let list = res.data;
						list.map((item) => {
							let obj = {
								value: item.id,
								label: item.typeName,
								leaf: node.level >=2,
							};
							nodes.push(obj)
						
						});
						resolve(nodes);
					})
				},
			},
			form:{
				"time":'',
				"area": "",//区
				"beizhu": "",//备注
				"city": "",//市
				"areaId": "",//区
				"cityId": "",//市
				"provinceId": "",//省
				"content": "",//描述
				"fwfl": "",//服务分类ID
				"fwflInfo": "",//服务分类
				// "img": "",//图片描述
				"lat": "34.74827",//纬度
				"lng": "113.612984",//经度
				"lxdz": "",//联系地址
				"lxrMobile": "",//联系人电话
				"lxrName": "",//联系人名称
				"memberYysj": "",//用户预约时间
				"mobile": "",//报修电话
				"msgCode": "",//验证码
				"msgId": "",//消息ID
				"name": "",//报修人名称
				"productId": "",//产品ID
				"province": "",//省
			},
			rules: {
				fwfl:[
					{ required: true, message: '请选择', trigger: 'blur' },
				],
				productId:[
					{ required: true, message: '请选择', trigger: 'blur' },
				],
				memberYysj: [
					{ required: true, message: '请选择预约时间', trigger: 'blur' },
				],
				province: [
					{ required: true, message: '请选择', trigger: 'blur' },
				],
				mobile: [
					{ required: true, message: '请输入报修电话', trigger: 'blur' },
				],
				lxdz: [
					{ required: true, message: '请输入详情地址', trigger: 'blur' },
				],
				msgCode: [
					{ required: true, message: '请输入验证码', trigger: 'blur' },
				],
				content: [
					{ required: true, message: '请输入', trigger: 'blur' },
				],
			},
			vcodeBtnName:'获取验证码',
			countNum : 120,
			countDownTimer : null,
			arrayTime:[],
		};
	},
	created() {
		EventBus.$on('globalVarChanged', (newValue) => {
			this.city = newValue;
			this.init();
		});
	},
	beforeDestroy() {
		EventBus.$off('globalVarChanged');
		clearInterval(this.scrollInterval); // 清理定时器
	},
	mounted() {
		   // 在 mounted 阶段将 sfList2 复制一份，使其足够长以支持滚动
 // this.sfList2 = [...this.sfList2, ...this.sfList2]; // 复制原数据
    this.sfList = [...this.sfList, ...this.sfList]; // 复制原数据
		//this.startScroll();
		//this.init();
		this.pTime();
	},
	methods: {

    //     startScrolling() {
    //   this.scrollInterval = setInterval(() => {
    //     this.scrollPosition += this.itemWidth; // 每次向右滚动一个 item 的宽度
    //     if (this.scrollPosition >= this.itemWidth * this.sfList2.length) {
    //       this.scrollPosition = 0; // 如果滚动到了最后，重置位置
    //     }
    //   }, 3000); // 每 3 秒滚动一次，您可以根据需要调整时间
    // },

//    startScroll() {
//     //   const scrollContainer = this.$refs.scrollContainer;
//     //   const bList = this.$refs.bList;
//     //   let scrollSpeed = 10; // 设置滚动速度
//     //   const maxScrollPosition = bList.scrollWidth - scrollContainer.offsetWidth;

//     //   const scroll = () => {
//     //     if (this.scrollPosition >= maxScrollPosition) {
//     //       this.scrollPosition = 0; // 如果滚动到最右边，重置为最左
//     //     } else {
//     //       this.scrollPosition += scrollSpeed; // 增加滚动位置
//     //     }

//     //     bList.style.transform = `translateX(-${this.scrollPosition}px)`; // 更新滚动位置
//     //     requestAnimationFrame(scroll); // 继续动画
//     //   };

//       const scrollContainer = this.$refs.scrollContainer;
//       const bList = this.$refs.bList;
//       const maxScrollPosition = bList.scrollWidth - scrollContainer.offsetWidth;

//       const scroll = () => {
//         if (this.scrollPosition >= maxScrollPosition) {
//           // 滚动到最右边时，先暂停一下，再重新开始从左边滚动
//           if (!this.isScrolling) {
//             this.isScrolling = true;
//             setTimeout(() => {
//               this.scrollPosition = 0; // 重新从左边开始
//               this.isScrolling = false;
//             }, 500); // 设置延迟时间，例如 500ms
//           }
//         } else {
//           this.scrollPosition += this.scrollSpeed; // 增加滚动位置
//         }

//         bList.style.transform = `translateX(-${this.scrollPosition}px)`; // 更新滚动位置
//         requestAnimationFrame(scroll); // 继续动画
//       };

//       scroll();


//      // scroll();
//     },
startScroll() {
  const scrollContainer = this.$refs.scrollContainer;
  const bList = this.$refs.bList;

  // 计算最大滚动位置
  const maxScrollPosition = bList.scrollWidth - scrollContainer.offsetWidth;

  const scroll = () => {
    // 如果滚动到最右边，重置位置
    if (this.scrollPosition >= maxScrollPosition) {
      this.scrollPosition = 0; // 重新从左边开始
    } else {
      this.scrollPosition += this.scrollSpeed; // 增加滚动位置
    }

    bList.style.transform = `translateX(-${this.scrollPosition}px)`; // 更新滚动位置
    requestAnimationFrame(scroll); // 继续动画
  };

  scroll();
},


		changeDate(value){
			console.log(value)
			let choosetamp = new Date(value).getTime()// 选择的时间戳
			let timestamp = new Date().getTime()// 当前的时间戳
			if(choosetamp>timestamp){
				this.pTime2();
			}else{
				this.pTime();
			}
		},
		// 选择时间 == 当前日期
		pTime(){
			let h = new Date().getHours();
			this.arrayTime = this.getArrayTime(h);
		},
		// 选择时间大于当前日期
		pTime2(){
			this.arrayTime = this.getArrayTime(0);
		},
		getArrayTime(h){
			console.log('444::',h)
			let arrayTime = [{h:1,val:'00:00-01:00'},{h:2,val:'01:00-02:00'},{h:3,val:'02:00-03:00'},{h:4,val:'03:00-04:00'},{h:5,val:'04:00-05:00'},{h:6,val:'05:00-06:00'},
			{h:7,val:'06:00-07:00'},{h:8,val:'07:00-08:00'},{h:9,val:'08:00-09:00'},{h:10,val:'09:00-10:00'},{h:11,val:'10:00-11:00'},{h:12,val:'11:00-12:00'},{h:13,val:'12:00-13:00'},
			{h:14,val:'13:00-14:00'},{h:15,val:'14:00-15:00'},{h:16,val:'15:00-16:00'},{h:17,val:'16:00-17:00'},{h:18,val:'17:00-18:00'},{h:19,val:'18:00-19:00'},{h:20,val:'19:00-20:00'},
			{h:21,val:'20:00-21:00'},{h:22,val:'21:00-22:00'},{h:23,val:'22:00-23:00'},{h:24,val:'23:00-24:00'}
			];
			let arr = []
			arrayTime.forEach(ele=>{
				if(ele.h>h){
					arr.push(ele)
				}
			})
			return arr
		},
		// 服务分类---选择
		handleChangeServer(e){
			console.log(e)
			this.form.fwfl = e[1];
			// getProductList
			let productTypeId = e[1];
			getProductList({pageIndex: 1,pageSize: 100,productTypeId: productTypeId}).then(res => {
				console.log(res)
				let list = res.data;
				this.list = list;
			})

		},
 		/**省市区三级联动 */
 		handleChange() {
			// console.log(this.selectedThree);
			// console.log(this.$refs.three.getCheckedNodes()[0].pathLabels);
			let arr = this.$refs.three.getCheckedNodes()[0].pathLabels
			this.form.province = arr[0];
			this.form.city = arr[1];
			this.form.area = arr[2];
			this.form.provinceId = this.selectedThree[0];
			this.form.cityId = this.selectedThree[1];
			this.form.areaId = this.selectedThree[2];
		},
		// 获取验证码
		getVCode(){
			var myreg=/^[1][0-9]{10}$/;
			if (!myreg.test(this.form.mobile)){
				this.$message({
				message: '请正确填写手机号码',
				type: 'warning'
				});
				return false;
			}
			// 手机号码为 :  this.phoneno
			// vcodeBtnName 可以阻止按钮被多次点击 多次发送 return 会终止函数继续运行
			if (this.vcodeBtnName != '获取验证码' && this.vcodeBtnName != '重新发送'){return ;}
			this.vcodeBtnName =  "发送中...";
			// 倒计时
			this.countNum = 60;
			this.countDownTimer = setInterval(function(){this.countDown();}.bind(this), 1000);
			// 与后端 api 交互，发送验证码
			const loading = this.$loading({
			lock: true,
			text: 'Loading',
			spinner: 'el-icon-loading',
			background: 'rgba(0, 0, 0, 0.7)'
			});
			sendMsgCode({mobile:this.form.mobile}).then(res => {
				loading.close();
				console.log(res)
				if(res.flag){
					this.form.msgId = res.data;
					this.$message(res.msg|| '短信已发送，请注意查收');
					// this.code = res.result
				}else{
					clearInterval(this.countDownTimer);
					this.$message(res.msg);
					this.vcodeBtnName =  "重新发送";
				}
				
			})
		},
		// 倒计时
		countDown(){
			if (this.countNum < 1){
				clearInterval(this.countDownTimer);
				this.vcodeBtnName = "重新发送";
				return ;
			}
			this.countNum--;
			this.vcodeBtnName =  this.countNum + '秒重发';
		},
		submitForm() {
			let formData = {...this.form}
			formData.lxrMobile = formData.mobile;
			console.log(this.form)
			if(!this.form.fwfl){
				this.$message('请选择服务分类');
				return false
			}
			if(!this.form.productId){
				this.$message('请选择服务产品');
				return false
			}
			if(!this.form.province){
				this.$message('请选择省市区');
				return false
			}
			if(!this.form.memberYysj){
				this.$message('请选择预约日期');
				return false
			}
			if(!this.form.time){
				this.$message('请选择预约时间段');
				return false
			}
			// let choosetamp = new Date(formData.memberYysj).getTime()// 选择的时间戳
			// let timestamp = new Date().getTime()// 当前的时间戳
			// timestamp = timestamp + 2 * 60 * 60 * 1000
			// if (choosetamp < timestamp) {
			// 	this.$message('请选择当前时间2个小时之后的时间')
			// 	return false
			// } 
			if(!this.form.content){
				this.$message('请输入维修内容');
				return false
			}
			if(!this.form.mobile){
				this.$message('请输入手机号');
				return false
			}
			if(!this.form.msgCode){
				this.$message('请输入验证码');
				return false
			}
			
			formData.memberYysj = formData.memberYysj +' '+ formData.time; 
			
			// return false
			orderCreate(formData).then(res => {
				if(res.flag){
					this.$message({
						message: res.msg,
						type: 'success'
					});
					this.form = {
						"time":"",
						"area": "",//区
						"beizhu": "",//备注
						"city": "",//市
						"areaId": "",//区
						"cityId": "",//市
						"provinceId": "",//省
						"content": "",//描述
						"fwfl": "",//服务分类ID
						"fwflInfo": "",//服务分类
						// "img": "",//图片描述
						"lat": "34.74827",//纬度
						"lng": "113.612984",//经度
						"lxdz": "",//联系地址
						"lxrMobile": "",//联系人电话
						"lxrName": "",//联系人名称
						"memberYysj": "",//用户预约时间
						"mobile": "",//报修电话
						"msgCode": "",//验证码
						"msgId": "",//消息ID
						"name": "",//报修人名称
						"productId": "",//产品ID
						"province": "",//省
					};
					this.selectedThree = [];
				}else{
					this.$message(res.msg);
				}
			})
			// this.$refs[formName].validate((valid) => {
			// 	if (valid) {
			// 		// lxrName 姓名
					
			// 	}
			// });
		},

		init(){
			this.getProductTypeList();
			this.getBanner();
			this.getShifuMemberList();
			//this.getShifuMemberList2();
			this.getProductList();
			this.getPtzzList();
			this.getArtice();
			this.getFwalList();
			this.getXwzxList();
		},
		//分类列表
		getProductTypeList(){
			getProductTypeAllList({flType:1,}).then(res => {
				console.log(res)
				let list = res.data;
				list.forEach(ele=>{
					ele.children.forEach(item=>{
						delete item.children
					})
				})
				this.sortArr = list;
				this.serverList = list;
			})
			// getProductTypeList({flType:1,}).then(res => {
			// 	console.log(res)
			// 	this.sortArr = res.data
			// })
		},
		// 轮播图
		getBanner(){
			getBannerList({type:'0'}).then(res => {
				console.log(res)
				this.banner = res.data
				this.loading = false
			})
		},
		// 产品列表
		getProductList(){
			getProductList({pageIndex:'1',pageSize:'5',city:this.city}).then(res => {
				let list = res.data;
				list.forEach(ele=>{
					if(ele.productImg){
						ele.productImg = ele.productImg.split(',')[0]
					}
				})
				this.productList = list;
				this.loading = false
			})
		},
		// 产品--详情
		goDetail(item){
			this.$router.push({
			path: '/server/detail',
				query: {
					id: item.id
				}
			})
		},
		// 师傅列表
		getShifuMemberList(){
			getShifuMemberList({pageIndex:'1',pageSize:'20',city:this.city,laiyuan:'官网api2'}).then(res => {
				let list = res.data;
				// scly
				list.forEach(ele=>{
					if(ele.sclyInfo){
						ele.sclyArr = ele.sclyInfo.split(',')
					}
				})
				this.sfList = list;
			})
		},

	// 师傅列表
		getShifuMemberList2(){
			getShifuMemberList({pageIndex:'1',pageSize:'5',city:this.city}).then(res => {
				let list = res.data;
				// scly
				list.forEach(ele=>{
					if(ele.sclyInfo){
						ele.sclyArr = ele.sclyInfo.split(',')
					}
				})
				this.sfList2 = list;
			})
		},





		// 平台资质
		getPtzzList(){
			getPtzzList({}).then(res => {
				let list = res.data;
				this.zzList = this.getArr(list,4);
			})
		},
		// 一维数组转二维数组 objArray:数组 n:每行显示个数
		getArr(objArray,n){
			// let objArray = [{a: 1}, {b: 2}, {c: 3}, {d: 4}, {e: 5}, {f: 6}, {g: 7}];
			let len = objArray.length;
			// let n = 4; //假设每行显示4个
			let lineNum = len % 4 === 0 ? len / 4 : Math.floor( (len / 4) + 1 );
			let res = [];
			for (let i = 0; i < lineNum; i++) {
				let temp = objArray.slice(i*n, i*n+n);
				res.push(JSON.parse(JSON.stringify(temp)));
			}
			console.log(res);
			return res
		},
		// 新闻咨询
		getXwzxList(){
			getXwzxList({"pageIndex": 1,"pageSize": 4}).then(res => {
				this.zxList = res.data;
			})
		},
		// 平台案例
		getFwalList(){
			
			getFwalList({"pageIndex": 1,"pageSize": 4}).then(res => {
				this.ptList = res.data;
			})
		},
		// 企业简介
		getArtice(){
			getArtice({type:'8'}).then(res => {
				this.articeObj = res.data;
			})
		},
		goUrl(url){
			this.$router.push({
				path: url,
				query: {}
			})
		},
		goNews(item){
			this.$router.push({
			path: '/news/detail',
				query: {
					id: item.id
				}
			})
		},
		// 去服务项目
		goServer(id,idIn){
			this.$router.push({
			path: '/server',
				query: {
					id: id,
					idIn:idIn,
				}
			})
		},
		goCase(item){
			this.$router.push({
			path: '/case/detail',
				query: {
					id: item.id
				}
			})
		},
		// 去师傅
		goMaster(item){
		console.log('777777666666');  // 在这里打印出点击的 item 数据
        console.log(item); 
		console.log(item.sfscore);
		console.log(item.id);  // 在这里打印出点击的 item 数据 item.sfscore
        console.log('66666677777'); 
			this.$router.push({
			path: '/master/detail',
				query: {
					id: item.id,
					sfscore: item.sfscore,  // 传递评分 sfscore
					sffwnum:item.sffwnum
				}
			})
		},
	},
};
</script>
<style lang="scss" scoped>

// /* 定义滚动动画 */
// .scroll-container {
//   display: flex;
//   overflow: hidden; /* 隐藏超出容器的部分 */

  
// }

// .b_list {
//   display: flex;
//   animation: scrollRight 10s linear infinite; /* 控制滚动的速度和循环方式 */
// }

// @keyframes scrollRight {
//   0% {
//     transform: translateX(0); /* 从0开始 */
//   }
//   100% {
//     transform: translateX(-100%); /* 滚动到100% */
//   }
// }

// /* 如果想要更平滑的滚动效果，可以添加ease */

// .scroll-container {
//    display: flex;
//   width: 100%;
//   overflow: hidden;
// }




// .b_list {
//   display: flex;
//   animation: scrollRight linear infinite;
//   animation-duration: 5s; /* 控制滚动速度 */
// }


@keyframes scroll {
  0% {
    transform: translateX(0); /* 从左侧开始 */
  }
  100% {
    transform: translateX(-100%); /* 滚动到最右边 */
  }
}


// /* 定义滚动的关键帧动画 */
// @keyframes scroll {
//     0% {
//         transform: translateX(0);
//     }
//     50% {
//         transform: translateX(-calc(224px * 5 + 20px * 4)); /* 滚动到原始内容的结尾 */
//     }
//     100% {
//         transform: translateX(0); /* 回到最初位置，避免卡顿 */
//     }

// }








.item {
  min-width: 200px; /* 每个项的宽度 */
  margin-right: 10px; /* 每个项之间的间隔 */
}


.home-container{background-color: #F5F8F9;padding-top:12px;
	.big_title{margin-bottom:16px;display: flex;align-items: center;justify-content: space-between;
		h2{color: #1F263F;font-size: 22px;font-weight: bold;}
		.more{display: flex;align-items: center;cursor: pointer;
			color: #A4A9B7;font-size: 14px;
			i{color: #A4A9B7;font-size:12px;margin-left: 6px;}
			&:hover{
				color: #2F78FF;
				i{color: #2F78FF;}
			}
		}
	}
	.box1{
		.cont{display: flex;justify-content: space-between;
			.b_left{width: 270px;height: 458px;background: #FFFFFF;border-radius: 8px 8px 8px 8px;padding: 8px 0;overflow-y: scroll;
				&::-webkit-scrollbar {display: none;}
				.item{padding: 8px 16px;cursor: pointer;
					.i_tit{display: flex;align-items: center;justify-content: space-between;
						h4{color: #1F263F;font-size: 14px;}
						i.icon-right{color: #A4A9B7;font-size: 12px;}
					}
					.tip{display: flex;align-items: center;margin-right:-16px;flex-wrap: wrap;
						span{color: #A4A9B7;font-size: 12px;margin-right: 16px;margin-top: 10px;
							&:hover{color: #2F78FF;}
						}
					}
					
				}
			}
			.b_min{flex: 1;padding:0 10px;
				.bnner{overflow: hidden;
					.img{width: 100%;height: 344px;border-radius: 8px 8px 8px 8px;object-fit: fill;}
				}
				.b_master{display: flex;justify-content: space-between;margin-top: 10px;
					.item{width: 324px;height: 104px;background: #FFFFFF;border-radius: 8px;padding: 12px;
						display: flex;align-items: center;


        /* 奖牌图标样式 */
        .medal-icon {
          width: 16px;
          height: 16px;
          margin-left: -59px;
          vertical-align: middle;  /* 保证与文字垂直居中对齐 */
        }

.type{width: 42px;height: 18px;line-height: 18px;text-align: center;background: #1C274C;border-radius: 4px;color: #F7C566;font-size: 12px;margin-left: -58px;}


						.img{width: 80px;height: 80px;background: #D9D9D9;border-radius: 4px;
							img{width: 100%;height: 100%;border-radius: 4px;}
						}
						.txt{flex: 1;padding-left:12px;
							.name{display: flex;justify-content: space-between;align-items: center;
								h4{color: #1F263F;font-size: 14px;font-weight: bold;}
								.xing{display: flex;align-items: center;
									color: #F39059;font-size: 14px;
									i{font-size: 12px;}
									span{font-weight: bold;margin-left: 5px;}
	        
									
								}
							}
							.tips{display: flex;align-items: center;min-height: 22px;
								.s_tip{padding: 0 6px;height: 22px;line-height: 22px;background: #F5F8F9;border-radius: 4px;color: #6B738B;font-size: 12px;margin-top: 4px;margin-right: 4px;}
							}
							.t_foot{display: flex;align-items: flex-end;justify-content: space-between;margin-top: 10px;
								span{color: #A4A9B7;font-size: 12px;}
								.btn{cursor: pointer;width: 72px;height: 26px;line-height: 26px;border-radius: 35px;border: 1px solid #2F78FF;color: #2F78FF;font-size: 12px;background-color: transparent;}
							}
						}
					}
				}
			}
			.b_right{width: 252px;height: 458px;background: linear-gradient( 180deg, #CDDEFB 0%, #FFFFFF 100%);border-radius: 8px;
				padding: 15px 12px 0;
				h3{color: #1F263F;font-size: 20px;text-align: center;font-weight: bold;margin-bottom: 5px;}
				p{color: #A4A9B7;font-size: 12px;text-align: center;margin-bottom: 10px;}
				.item{width: 228px;height: 40px;background: #FFFFFF;border-radius: 8px;position: relative;margin-bottom: 8px;display: flex;align-items: center;
					/* &.h_auto{min-height: 40px;height: 60px;} */
					/*修改下拉框背景色以及边框线样式*/
					/deep/ .el-select{border: 0;width: 100%;}
					/deep/ .el-cascader{border: 0;width: 100%;}
					/deep/ .el-input__inner{border: none;border-radius: 8px;}
					/deep/ .el-textarea{border: 0;width: 100%;}
					/deep/ .el-textarea__inner{border: none;border-radius: 8px;height: 30px;}
					.yan{color: #2F78FF;font-size: 14px;flex: 0 0 80px;cursor: pointer;}
				}
				.form_btn{margin-top: 0px;width: 228px;color: #FFFFFF;font-size: 14px;height: 40px;background: #2F78FF;border-radius: 8px;border: 0;cursor: pointer;}
			}
		}
	}
	.box2{margin-top: 10px;
		.cont{display: flex;align-items: center;
			.item{width: 224px;background: #FFFFFF;border-radius: 8px;margin-right: 20px;overflow: hidden;
				&:last-child{margin-right: 0;}
				.img{width: 100%;background: #D9D9D9;overflow: hidden;
					img{width: 100%;height: 100%;transition: all .6s;}
				}
				.txt{padding: 12px;
					h3{color: #1F263F;font-size: 16px;font-weight: bold;margin-bottom: 10px;transition: all .3s;}
					p{color: #A4A9B7;font-size: 12px;}
				}
				&:hover{
					img{transform: scale(1.2);}
					h3{color: #2F78FF;}
				}
			}
		}
	}
	.box3{margin-top: 10px;height: 94px;background: #FFFFFF;padding: 0 30px;display: flex;align-items: center;justify-content: space-between;
		.item{flex: 1;display: flex;align-items: center;
			.img{width: 40px;height: 40px;}
			.txt{margin-left: 16px;
				h3{color: #1F263F;font-size: 16px;font-weight: bold;margin-bottom: 6px;}
				p{color: #A4A9B7;font-size: 12px;}
			}

		}
	}
	.box4{margin-top: 24px;
        
//   .scroll-container {
//     display: flex;  /* 使用 flexbox 布局，确保 b_list 并排 */
//     justify-content: flex-start;  /* 可以选择左对齐或其他对齐方式 */
//     overflow: hidden;
//     width: 100%;
//   }
.scroll-container {
    overflow: hidden;
    width: 100%; /* 容器宽度 */
}
		// .b_list{display: flex;align-items: center;flex-wrap: wrap  ;
			.b_list{display: flex;  flex-wrap: nowrap;   animation: scroll 30s linear infinite; /* 设置动画 */


			
			.item{margin-right: 20px;margin-bottom: 20px;width: 224px;min-height: 320px;background: #FFFFFF;border-radius: 8px;padding: 8px;position: relative;transition: all .1s;
				&:nth-child(5n+5){margin-right: 0;}
				.img{width: 208px;height: 208px;background: #D9D9D9;border-radius: 8px;overflow: hidden;
					img{width: 100%;height: 100%;transition: all .6s;}
				}

				.type88{width: 42px;height: 18px;line-height: 18px;text-align: center;background: #1C274C;border-radius: 4px;color: #F7C566;font-size: 12px;margin-left: -148px}
				.txt{margin-top: 15px;padding-left: 8px;
					h4{color: #1F263F;font-size: 16px;font-weight: bold;margin-bottom: -19px;}
					.tips{display: flex;align-items: center;flex-wrap: wrap; min-height: 22px;  /* 设置最小高度，避免没有内容时，影响布局 */
						.s_tip{padding: 0 6px;height: 22px;line-height: 22px;background: #F5F8F9;border-radius: 4px;color: #6B738B;font-size: 12px;margin-top: 4px;margin-right: 4px;}
					}
					.i_foot{display: flex;align-items: center;color: #A4A9B7;font-size: 12px;margin-top: 9px;
						.xing{display: flex;align-items: center;margin-right: 8px;
							color: #F39059;font-size: 14px;
							i{font-size: 12px;}
							span{font-weight: bold;margin-left: 5px;}
						}
					}
				}
				&:hover{
					img{transform: scale(1.2);}
					h4{color: #2F78FF;}
				}
			}


			
		}
	}
	.box5{margin-top: 12px;background: url(../../../static/index/bg.png) no-repeat;background-size: 100% 100%;
		.cont{padding-top: 64px;position: relative;padding-bottom: 40px;
			h3{color: #FFFFFF;font-size: 36px;font-weight: bold;text-align: center;margin-bottom: 10px;}
			p{color: #A4A9B7;font-size: 18px;text-align: center;}
			.mySwiper{margin-top: 40px;position: relative;padding-bottom: 30px;display: flex;align-items: center;
				.swiper-slide{width: 25%;
					.img{width: 270px;height: 360px;}
					.btn{margin: 32px auto;color: #FFFFFF;font-size: 20px;width: 220px;height: 50px;line-height: 50px;text-align: center;background: linear-gradient( 90deg, #CA875A 0%, #EDB995 100%);border-radius: 35px;}
				}
			}
			.swiper-next{position: absolute;top: 50%;bottom: 0;right: -80px;
				img{width: 50px;cursor: pointer;}
			}
			.swiper-prev{position: absolute;top: 50%;bottom: 0;left: -80px;
				img{width: 50px;cursor: pointer;}
			}
		}
	}
	.box6{margin-top: 24px;
		.b_listt{display: flex;
			.l_left{width: 603px;height: 358px;position: relative;overflow: hidden;border-radius: 10px;cursor: pointer;
				.img{width: 100%;height: 100%;border-radius: 10px;}
				.in_title{position: absolute;left: 0;right: 0;bottom: 0;height: 112px;background: linear-gradient( 180deg, rgba(0,0,0,0) 0%, rgba(0,0,0,.5) 100%);padding: 16px;
					display: flex;flex-direction: row;align-items: flex-end;
					h4{color: #FFFFFF;font-size: 20px;transition: all .3s;}
				}
				&:hover{
					h4{color: #2F78FF;}
				}
			}
			.l_right{margin-left: 20px;
				.item{display: flex;align-items: center;margin-bottom: 20px;cursor: pointer;
					&:last-child{margin-bottom: 20px;}
					.img{width: 140px;height: 106px;background: #D9D9D9;border-radius: 10px;}
					.txt{margin-left: 16px;flex: 1;display: flex;flex-direction: column;justify-content: space-between;
						h4{color: #333333;font-size: 18px;margin-bottom: 8px;font-weight: bold;transition: all .3s;}
						p{color: #A4A9B7;font-size: 14px;margin-bottom: 10px;line-height: 16px;}
						span{color: #A4A9B7;font-size: 12px;}
					}
					&:hover{
						.txt{
							h4{color: #2F78FF;}
						}
					}
				}
			}
		}
	}
	.box7{margin-top: 32px;
		.list{display: flex;align-items: center;
			.item{width: 285px;height: 285px;background: #FFFFFF;border-radius: 8px;overflow: hidden;position: relative;margin-right: 20px;margin-bottom: 20px;cursor: pointer;
				&:last-child{margin-right: 0;}
				.img{width: 100%;height: 100%;transition: all .3s;}
				h4{position: absolute;left: 0;right: 0;bottom: 0;line-height: 40px;text-align: center;color: #FFFFFF;font-size: 14px;height: 40px;background: rgba(0,0,0,0.5);border-radius: 0px 0px 8px 8px;}
				&:hover{
					.img{transform: scale(1.2);}
					h4{color: #2F78FF;}
				}
			}
		}
	}
	.box8{background: #FFFFFF;border-radius: 8px;margin-bottom: 47px;padding: 44px;
		display: flex;
		.img{width: 288px;height: 504px;}
		.r_world{margin-left: 34px;flex: 1;background: #F5F8F9;min-height: 504px;padding: 20px 0;
			display: flex;align-items: center;justify-content: space-around;
			.txt{width: 85%;
				h4{color: #1F263F;font-size: 40px;font-weight: bold;margin-bottom: 32px;}
				.dec{color: #1F263F;font-size: 16px;margin-bottom: 26px;line-height: 30px;
					p{color: #1F263F;font-size: 16px;margin-bottom: 26px;line-height: 30px;
						&:last-child{margin-bottom: 0;}
					}
				}
				
			}
		}
	}
}
</style>


// WEBPACK FOOTER //
// src/views/home/index.vue